module.exports = function(posts) {
	'use strict'
	posts.directive('revisionsModal',revisionsModal);
	revisionsModal.$inject=['$timeout','getDataService','$rootScope','activeClass','refreshtokenService','cleanObj','alertService','serverError','offlineError'];
	function revisionsModal($timeout,getDataService,$rootScope,activeClass,refreshtokenService,cleanObj, alertService,serverError,offlineError) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj:"="
			},
			template: require('./partial/revisions.html'),
			link: function(scope, ele, $attrs, ctrl) {
				var state = 'posts';
				scope.loadRevisions = false;
				var selectRevisionFunction = function(index) {
					if(scope.revisions[index].content) {
						scope.leftContent = scope.revisions[index].content;
					} else {
						scope.leftContent = '';
					}
					if(scope.revisions[index].title) {
		          		scope.leftTitle = scope.revisions[index].title;
					} else {
						scope.leftTitle = '';
					}
		          	if(scope.revisions[index].subtitle) {
		          		scope.leftSubtitle = scope.revisions[index].subtitle;
		          	} else {
		          		scope.leftSubtitle = '';
		          	}
		          	scope.revisionAuthor = scope.revisions[index].author.display_name;
		          	scope.revisionDate = scope.revisions[index].date_modified;
				}
				var getPostData = function() { 
			        getDataService.get({param1:'posts', param2:'revisions' ,param3: scope.currentPostObj.postId}).$promise.then(function(data){
			          scope.revisions = data.revisions;
			          scope.loadRevisions = true;
			          var defaultRevisionsIndex = scope.revisions.length-1;
			          scope.selectedRevisions ={value:defaultRevisionsIndex.toString()}; 
			          selectRevisionFunction(defaultRevisionsIndex);
			        }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							return
						}
			          	if(error.status ==401) {
				            var promise = refreshtokenService.getAccessToken();
				            promise.then(
				              function(answer) {
				                if(answer==200) {
				                  getPostData();
				                }
				                // do something
				              },
				              function(error) {
				                // report something
				              },
				              function(progress) {
				               // report progress
				            });
			          	} else if(error.status ==502) {
			            	serverError()
			          	} else if(error.status == 404){
			          		scope.loadRevisions = false;
			          	} else {
			            	alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
			          	}
			        });
		      	}
		      	getPostData();
		      	scope.changeRevisions = function(index) {
		      		var index = parseInt(index);
		      		selectRevisionFunction(index);
		      	}
				scope.options = {
					// interLineDiff: false,
     //    			ignoreTrailingNewLines: true,
        			attrs: {
			          insert: {
			            'data-attr': 'insert',
			            'class': 'insertion'
			          },
			          delete: {
			            'data-attr': 'delete'
			          },
			          equal: {
			            'data-attr': 'equal'
			          }
			        }
				}	
				scope.rightContent = scope.currentPostObj.textEditorContent;
				scope.rightTitle = scope.currentPostObj.dataPost.title;
				scope.rightSubtitle = scope.currentPostObj.dataPost.subtitle;
				scope.restorePost = function() {
					var post = {
						'title': scope.leftTitle,
						'subtitle': scope.leftSubtitle,
						'content': scope.leftContent,
						'author':scope.revisionAuthor,
						'date':scope.revisionDate
					}
					scope.$emit('restore-post',{post:post});
					$timeout(function() {
						scope.currentPostObj.cancelRevisionsModal();
					},0)
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/revisionsDirective.js
// module id = 561
// module chunks = 0